import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getAllSheetSettings } from "../../../redux/actions/sheetSettings";
import { getAllWebhookSettings } from "../../../redux/actions/webhookSettings";
import { getOverallMessageGroups } from "../../../redux/actions/messageGroupSettings";

const intialGroupSettings = {
  operationProcedure: {
    getGenderInfo: false,
    ifAllAnswered: false,
    sendMessageIfReqAccept: { value: false, messageGroup: null },
    sendMessageIfReqDecline: { value: false, messageGroup: null },
    autoDecline: { value: false, messageGroup: null },
    sendMessageForQuestion: {
      value: false,
      messageGroup: null,
      question: "",
      answer: "",
    },
    preApproveSheet: "",
    verifyEmail: "",
    emailQuestion: "",
    emailQuestionForPreApproved: "",
    delayTime: 0,
  },
  exportOption: {
    webhook: "",
    exportSheet: "",
    csvDownload: false,
  },
};

const CheckBox = ({ style, label, checked, onChange }) => (
  <div className="individualCheckBox" style={style}>
    <label className="checkBoxText">
      {label}
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="checkmark"></span>
    </label>
  </div>
);

const AutoApproveForm = ({
  groupSetting,
  selectedAutomation,
  userInfo,
  groupDetails,
  onChange,
}) => {
  // const groupDetails = {};
  // console.log("groupDetails", groupDetails);
  const sheetSettings = useSelector((state) => state.sheetSettings);
  const { sheets } = sheetSettings;
  const webhookSettings = useSelector((state) => state.webhookSettings);
  const { webhooks } = webhookSettings;
  // console.log("webhooks", webhooks);
  const messageGroupsSettings = useSelector(
    (state) => state.messageGroupsSettings
  );
  const { allMessageGroups: messageGroups } = messageGroupsSettings;
  const dispatch = useDispatch();

  const [groupSettings, setGroupSettings] = useState({
    operationProcedure: {
      ...intialGroupSettings.operationProcedure,
      getGenderInfo: parseInt(userInfo?.planNo) === 5 ? true : false,
    },
    exportOption: {
      ...intialGroupSettings.exportOption,
    },
  });
  // console.log("groupSettings", groupSettings);
  const [preApproveSheetOpen, setpreApproveSheetOpen] = useState(false);
  const [invalidEmailAction, setInvalidEmailAction] = useState(false);
  const [webhookExportOption, setWebhookExportOption] = useState(false);
  const [googleSheetExportOption, setGoogleSheetExportOption] = useState(false);

  useEffect(() => {
    if (groupSetting?.operationProcedure) {
      setGroupSettings({
        operationProcedure: {
          ...groupSetting.operationProcedure,
          verifyEmail: groupSetting.operationProcedure?.autoDecline?.value
            ? "decline"
            : groupSettings?.operationProcedure?.verifyEmail,
        },
        exportOption: groupSetting.exportOption,
      });
    } else {
      setGroupSettings({
        operationProcedure: {
          ...intialGroupSettings.operationProcedure,
          getGenderInfo: parseInt(userInfo?.planNo) === 5 ? true : false,
        },
        exportOption: {
          ...intialGroupSettings.exportOption,
        },
      });
    }
    setInvalidEmailAction(() =>
      groupSetting?.operationProcedure?.verifyEmail &&
      groupSetting?.operationProcedure?.emailQuestion
        ? true
        : false
    );
    setpreApproveSheetOpen(() =>
      groupSetting?.operationProcedure?.preApproveSheet ? true : false
    );
    setGoogleSheetExportOption(() =>
      groupSetting?.exportOption?.exportSheet ? true : false
    );
    setWebhookExportOption(() =>
      groupSetting?.exportOption?.webhook ? true : false
    );
  }, [groupSetting]);

  useEffect(() => {
    const selectedAutomationGroupSettings = selectedAutomation.groupSettings;
    if (selectedAutomationGroupSettings?.operationProcedure) {
      setGroupSettings({
        operationProcedure: {
          ...selectedAutomationGroupSettings.operationProcedure,
          sendMessageIfReqAccept: {
            ...selectedAutomationGroupSettings.operationProcedure
              .sendMessageIfReqAccept,
            messageGroup:
              selectedAutomationGroupSettings.operationProcedure
                .sendMessageIfReqAccept?.messageGroup?._id,
          },
          sendMessageForQuestion: {
            ...selectedAutomationGroupSettings.operationProcedure
              .sendMessageForQuestion,
            messageGroup:
              selectedAutomationGroupSettings.operationProcedure
                .sendMessageForQuestion?.messageGroup?._id,
          },
          autoDecline: {
            ...selectedAutomationGroupSettings.operationProcedure.autoDecline,
            messageGroup:
              selectedAutomationGroupSettings.operationProcedure.autoDecline
                ?.messageGroup?._id,
          },
        },
        exportOption: selectedAutomationGroupSettings.exportOption,
      });
      setInvalidEmailAction(() =>
        selectedAutomationGroupSettings?.operationProcedure?.verifyEmail &&
        selectedAutomationGroupSettings?.operationProcedure?.emailQuestion
          ? true
          : false
      );
      setpreApproveSheetOpen(() =>
        selectedAutomationGroupSettings?.operationProcedure?.preApproveSheet
          ? true
          : false
      );
      setGoogleSheetExportOption(() =>
        selectedAutomationGroupSettings?.exportOption?.exportSheet
          ? true
          : false
      );
      setWebhookExportOption(() =>
        selectedAutomationGroupSettings?.exportOption?.webhook ? true : false
      );
    }
  }, [selectedAutomation]);

  // console.log("groupSettings", groupSettings)
  // console.log("selectedAutomation", selectedAutomation)

  useEffect(() => {
    dispatch(getAllSheetSettings());
    dispatch(getAllWebhookSettings());
    dispatch(getOverallMessageGroups());
  }, [dispatch]);

  useEffect(() => {
    if (groupSettings) {
      onChange({
        ...groupSettings,
        preApproveSheetOpen,
        invalidEmailAction,
        webhookExportOption,
        googleSheetExportOption,
      });
    }
  }, [
    groupSettings,
    preApproveSheetOpen,
    invalidEmailAction,
    webhookExportOption,
    googleSheetExportOption,
  ]);

  return (
    <div className="autoApproveForm">
      <div>
        <span className="lalel title">
          Please tell us how you want to proceed
        </span>
      </div>
      <div className="flex">
        <div className="flex-col-6">
          <CheckBox
            label="Get Gender, Country, Tier"
            checked={groupSettings?.operationProcedure?.getGenderInfo}
            onChange={() => {
              if (userInfo.planNo < 5) {
                setGroupSettings({
                  operationProcedure: {
                    ...groupSettings.operationProcedure,
                    getGenderInfo: false,
                  },
                  exportOption: {
                    ...groupSettings.exportOption,
                  },
                });
                toast.info(
                  "Please upgrade your account to get gender, country & tier info of a member !"
                );
              } else {
                setGroupSettings({
                  operationProcedure: {
                    ...groupSettings.operationProcedure,
                    getGenderInfo:
                      !groupSettings.operationProcedure.getGenderInfo,
                  },
                  exportOption: {
                    ...groupSettings.exportOption,
                  },
                });
              }
            }}
          />
        </div>
        <div className="flex-col-6">
          <CheckBox
            label="Only approve if answered all questions"
            checked={groupSettings.operationProcedure?.ifAllAnswered}
            onChange={(e) => {
              setGroupSettings({
                operationProcedure: {
                  ...groupSettings.operationProcedure,
                  ifAllAnswered:
                    !groupSettings["operationProcedure"]["ifAllAnswered"],
                },
                exportOption: {
                  ...groupSettings.exportOption,
                },
              });
            }}
          />
        </div>
      </div>

      <div className="flex">
        <div className="flex-col-6">
          <CheckBox
            label="Only approve if pre-approved"
            checked={preApproveSheetOpen}
            onChange={(e) => {
              if (userInfo.planNo < 3) {
                setGroupSettings({
                  operationProcedure: {
                    ...groupSettings.operationProcedure,
                    preApproveSheet: "",
                  },
                  exportOption: {
                    ...groupSettings.exportOption,
                  },
                });
                setpreApproveSheetOpen(false);
                toast.info(
                  "Please upgrade your account to use pre-approve feature !"
                );
              } else {
                if (e.target.checked === false) {
                  setGroupSettings({
                    operationProcedure: {
                      ...groupSettings.operationProcedure,
                      preApproveSheet: "",
                    },
                    exportOption: {
                      ...groupSettings.exportOption,
                    },
                  });
                }
                setpreApproveSheetOpen(e.target.checked);
              }
            }}
          />
          <div
            className={
              preApproveSheetOpen
                ? "individualCheckBox selectDropsOnly"
                : "individualCheckBox selectDropsOnly disabled"
            }
          >
            <span className="dropdownOptions onlySelectsOptions">
              <div className="selectWraper drpOptions">
                <select
                  className="dropSelect"
                  onChange={(e) => {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                        preApproveSheet: e.target.value,
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                      },
                    });
                  }}
                  value={
                    groupSettings?.operationProcedure?.preApproveSheet || ""
                  }
                >
                  <option value="">Select google sheet</option>
                  {sheets &&
                    sheets
                      .filter((sheet) => sheet.type === "preApprove")
                      .map((sheet) => {
                        return (
                          <option key={sheet._id} value={sheet._id}>
                            {sheet.spreadsheetTitle}
                          </option>
                        );
                      })}
                </select>
              </div>
            </span>
          </div>
          <div
            className={
              preApproveSheetOpen
                ? "individualCheckBox selectDropsOnly"
                : "individualCheckBox selectDropsOnly disabled"
            }
          >
            <span className="dropdownOptions onlySelectsOptions">
              <div className="selectWraper drpOptions">
                <select
                  className="dropSelect"
                  value={
                    groupSettings?.operationProcedure
                      ?.emailQuestionForPreApproved
                  }
                  onChange={(e) =>
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                        emailQuestionForPreApproved: e.target.value,
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                      },
                    })
                  }
                >
                  <option value="">Select Your Email Question</option>
                  {groupDetails?.membershipQuestions &&
                    groupDetails?.membershipQuestions.length > 0 &&
                    groupDetails?.membershipQuestions.map((question, index) => {
                      return (
                        <option key={question.id} value={question.id}>
                          {question.question}
                        </option>
                      );
                    })}
                </select>
              </div>
            </span>
          </div>
        </div>
        <div className="flex-col-6">
          <CheckBox
            label="Verify Email address"
            checked={invalidEmailAction}
            onChange={(e) => {
              if (userInfo.planNo < 4) {
                setGroupSettings({
                  operationProcedure: {
                    ...groupSettings.operationProcedure,
                    verifyEmail: "",
                  },
                  exportOption: {
                    ...groupSettings.exportOption,
                  },
                });
                setInvalidEmailAction(false);
                toast.info(
                  "Please upgrade your account to use email verification feature !"
                );
              } else {
                const emailAction = groupSettings.operationProcedure
                  ?.autoDecline?.value
                  ? "decline"
                  : groupSettings?.operationProcedure?.verifyEmail;
                setGroupSettings({
                  operationProcedure: {
                    ...groupSettings.operationProcedure,
                    verifyEmail: e.target.checked === false ? "" : emailAction,
                    emailQuestion:
                      e.target.checked === false
                        ? ""
                        : groupSettings?.operationProcedure?.emailQuestion,
                  },
                  exportOption: {
                    ...groupSettings.exportOption,
                  },
                });
                setInvalidEmailAction(e.target.checked);
              }
            }}
          />
          <div
            className={
              invalidEmailAction
                ? "individualCheckBox selectDropsOnly"
                : "individualCheckBox selectDropsOnly disabled"
            }
          >
            <span className="dropdownOptions onlySelectsOptions activated">
              <div className="selectWraper drpOptions">
                <select
                  className="dropSelect"
                  onChange={(e) => {
                    if (userInfo.planNo < 4) {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          verifyEmail: "",
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                      setInvalidEmailAction(false);
                      toast.info(
                        "Please upgrade your account to use email verification feature !"
                      );
                    } else {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          verifyEmail: e.target.value,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }
                  }}
                  value={groupSettings?.operationProcedure?.verifyEmail || ""}
                  disabled={
                    groupSettings.operationProcedure?.autoDecline?.value
                  }
                >
                  <option value="">Select action for invalid Email</option>
                  <option value="skip">Don't approve the request</option>
                  <option value="decline">Decline the request</option>
                </select>
              </div>
            </span>
          </div>

          <div
            className={
              invalidEmailAction
                ? "individualCheckBox selectDropsOnly"
                : "individualCheckBox selectDropsOnly disabled"
            }
          >
            <span className="dropdownOptions onlySelectsOptions">
              <div className="selectWraper drpOptions">
                <select
                  className="dropSelect"
                  value={groupSettings?.operationProcedure?.emailQuestion}
                  onChange={(e) =>
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                        emailQuestion: e.target.value,
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                      },
                    })
                  }
                >
                  <option value="">Select Your Email Question</option>
                  {groupDetails?.membershipQuestions.map((question, index) => {
                    return (
                      <option key={question.id} value={question.id}>
                        {question.question}
                      </option>
                    );
                  })}
                </select>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div className="flex">
        <div className="flex-col-6">
          <div>
            <CheckBox
              label="Send message if join request is accepted:"
              checked={
                groupSettings.operationProcedure?.sendMessageIfReqAccept?.value
              }
              onChange={(e) => {
                if (userInfo.planNo < 5) {
                  toast.info(
                    "Please upgrade your account to use messaging feature !"
                  );
                } else {
                  setGroupSettings({
                    operationProcedure: {
                      ...groupSettings.operationProcedure,
                      sendMessageIfReqAccept: {
                        ...groupSettings.operationProcedure
                          ?.sendMessageIfReqAccept,
                        value:
                          !groupSettings["operationProcedure"][
                            "sendMessageIfReqAccept"
                          ]["value"],
                      },
                    },
                    exportOption: {
                      ...groupSettings.exportOption,
                    },
                  });
                }
              }}
            />

            <div
              className={
                groupSettings?.operationProcedure?.sendMessageIfReqAccept?.value
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  <select
                    className="dropSelect"
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageIfReqAccept: {
                            ...groupSettings?.operationProcedure
                              ?.sendMessageIfReqAccept,
                            messageGroup:
                              e.target.value === "" || !e.target.value
                                ? null
                                : e.target.value,
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                    value={
                      groupSettings?.operationProcedure?.sendMessageIfReqAccept
                        ?.messageGroup || ""
                    }
                  >
                    <option value="">Select Message Group</option>
                    {messageGroups?.map((messageGrup) => {
                      return (
                        <option key={messageGrup._id} value={messageGrup._id}>
                          {messageGrup.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </span>
            </div>
          </div>
          <div>
            <CheckBox
              style={{ marginTop: "20px" }}
              label="Auto decline members:"
              checked={groupSettings.operationProcedure?.autoDecline?.value}
              onChange={(e) => {
                if (userInfo.planNo < 5) {
                  toast.info(
                    "Please upgrade your account to use messaging feature !"
                  );
                } else {
                  setGroupSettings({
                    operationProcedure: {
                      ...groupSettings.operationProcedure,
                      verifyEmail: invalidEmailAction ? "decline" : "",
                      autoDecline: {
                        ...groupSettings.operationProcedure?.autoDecline,
                        value:
                          !groupSettings["operationProcedure"]["autoDecline"][
                            "value"
                          ],
                      },
                    },
                    exportOption: {
                      ...groupSettings.exportOption,
                    },
                  });
                }
              }}
            />

            <div
              className={
                groupSettings.operationProcedure?.autoDecline?.value
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  {/* <img src={arrowSelectImg} className='arrowIngDrop' alt='' /> */}
                  <select
                    className="dropSelect"
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          autoDecline: {
                            ...groupSettings?.operationProcedure?.autoDecline,
                            messageGroup:
                              e.target.value === "" || !e.target.value
                                ? null
                                : e.target.value,
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                    value={
                      groupSettings?.operationProcedure?.autoDecline
                        ?.messageGroup || ""
                    }
                  >
                    <option value="">Select Message Group</option>
                    {messageGroups?.map((messageGrup) => {
                      return (
                        <option key={messageGrup._id} value={messageGrup._id}>
                          {messageGrup.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </span>
            </div>
          </div>
          <div>
            <div className="individualCheckBox" style={{ marginTop: "20px" }}>
              <label className="checkBoxText" style={{ paddingLeft: 0 }}>
                Default delay time for messaging (In seconds):
              </label>
            </div>

            <div className="selectWraper drpOptions">
              <input
                className="dropSelect delayTimimg message-segment-input bg-transparent"
                type="number"
                min="0"
                style={{
                  padding: "11px 20px",
                  marginBottom: "0",
                  height: "40px",
                  width: "140px",
                }}
                placeholder="E.g. 30"
                value={groupSettings?.operationProcedure?.delayTime}
                onChange={(e) => {
                  setGroupSettings({
                    operationProcedure: {
                      ...groupSettings.operationProcedure,
                      delayTime: e.target.value,
                    },
                    exportOption: {
                      ...groupSettings.exportOption,
                    },
                  });
                }}
              />
            </div>
            <span
              style={{
                fontSize: "10px",
                color: "#9BAEBC",
              }}
            >
              *Note: By default there will be a 60 seconds random delay
            </span>
          </div>
        </div>
        <div className="flex-col-6">
          <CheckBox
            label="Send message only for specific question:"
            checked={
              groupSettings.operationProcedure?.sendMessageForQuestion?.value
            }
            onChange={(e) => {
              if (userInfo.planNo < 5) {
                toast.info(
                  "Please upgrade your account to use messaging feature !"
                );
              } else {
                setGroupSettings({
                  operationProcedure: {
                    ...groupSettings.operationProcedure,
                    sendMessageForQuestion: {
                      ...groupSettings.operationProcedure
                        ?.sendMessageForQuestion,
                      value:
                        !groupSettings["operationProcedure"][
                          "sendMessageForQuestion"
                        ]["value"],
                    },
                  },
                  exportOption: {
                    ...groupSettings.exportOption,
                  },
                });
              }
            }}
          />

          <div
            className={
              groupSettings?.operationProcedure?.sendMessageForQuestion?.value
                ? "individualCheckBox selectDropsOnly"
                : "individualCheckBox selectDropsOnly disabled"
            }
          >
            <span className="dropdownOptions onlySelectsOptions">
              <div className="selectWraper drpOptions">
                {/* <img src={arrowSelectImg} className='arrowIngDrop' alt='' /> */}
                <select
                  className="dropSelect"
                  onChange={(e) => {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                        sendMessageForQuestion: {
                          ...groupSettings.operationProcedure
                            ?.sendMessageForQuestion,
                          messageGroup:
                            e.target.value === "" || !e.target.value
                              ? null
                              : e.target.value,
                        },
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                      },
                    });
                  }}
                  value={
                    groupSettings?.operationProcedure?.sendMessageForQuestion
                      ?.messageGroup || ""
                  }
                >
                  <option value="">Select Message Group</option>
                  {messageGroups?.map((messageGroup) => {
                    return (
                      <option key={messageGroup._id} value={messageGroup._id}>
                        {messageGroup.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </span>
          </div>
          <div
            className={
              groupSettings?.operationProcedure?.sendMessageForQuestion?.value
                ? "individualCheckBox selectDropsOnly"
                : "individualCheckBox selectDropsOnly disabled"
            }
          >
            {/* {groupSettings?.operationProcedure?.sendMessageForQuestion
            ?.value && ( */}
            <span className="dropdownOptions onlySelectsOptions">
              <div className="selectWraper drpOptions">
                <select
                  className="dropSelect"
                  value={
                    groupSettings?.operationProcedure?.sendMessageForQuestion
                      ?.question
                  }
                  onChange={(e) => {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                        sendMessageForQuestion: {
                          ...groupSettings.operationProcedure
                            ?.sendMessageForQuestion,
                          question: e.target.value,
                          answer: "",
                        },
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                      },
                    });
                  }}
                >
                  <option value="">Select a valid question</option>
                  {groupDetails?.membershipQuestions
                    ?.filter((item) => item.questionType === "MULTIPLE_CHOICE")
                    .map((question, index) => {
                      return (
                        <option key={question.id} value={question.id}>
                          {question.question}
                        </option>
                      );
                    })}
                </select>
              </div>
            </span>
          </div>
          <div
            className={
              groupSettings?.operationProcedure?.sendMessageForQuestion?.value
                ? "individualCheckBox selectDropsOnly"
                : "individualCheckBox selectDropsOnly disabled"
            }
          >
            <span className="dropdownOptions onlySelectsOptions">
              <div className="selectWraper drpOptions">
                <select
                  className="dropSelect"
                  value={
                    groupSettings?.operationProcedure?.sendMessageForQuestion
                      ?.answer
                  }
                  onChange={(e) => {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                        sendMessageForQuestion: {
                          ...groupSettings.operationProcedure
                            ?.sendMessageForQuestion,
                          answer: e.target.value,
                        },
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                      },
                    });
                  }}
                >
                  <option value="">Select a valid answer</option>
                  {groupDetails?.membershipQuestions
                    ?.find(
                      (question) =>
                        question.id ===
                        groupSettings?.operationProcedure
                          ?.sendMessageForQuestion?.question
                    )
                    ?.options?.map((option, index) => {
                      return (
                        <option key={option.optionId} value={option.optionId}>
                          {option.value}
                        </option>
                      );
                    })}
                </select>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div>
        <span className="title">Export Options</span>
        <div className="flex">
          <div className="flex-col-6">
            <CheckBox
              label="Send data to Webhook"
              checked={webhookExportOption}
              onChange={(e) => {
                setWebhookExportOption(e.target.checked);
                !e.target.checked &&
                  setGroupSettings({
                    operationProcedure: {
                      ...groupSettings.operationProcedure,
                    },
                    exportOption: {
                      ...groupSettings.exportOption,
                      webhook: "",
                    },
                  });
              }}
            />
            <div className="individualCheckBox">
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  <select
                    disabled={!webhookExportOption ? true : false}
                    value={groupSettings["exportOption"]["webhook"] || ""}
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                          webhook: e.target.value,
                        },
                      });
                    }}
                  >
                    <option value="">
                      Select webhook to send exported data
                    </option>
                    {webhooks &&
                      webhooks.map((web) => {
                        return (
                          <option key={web._id} value={web._id}>
                            {web.title}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </span>
            </div>
          </div>
          <div className="flex-col-6">
            <CheckBox
              label="Send data to Google Sheet"
              checked={googleSheetExportOption}
              onChange={(e) => {
                setGoogleSheetExportOption(e.target.checked);
                !e.target.checked &&
                  setGroupSettings({
                    operationProcedure: {
                      ...groupSettings.operationProcedure,
                    },
                    exportOption: {
                      ...groupSettings.exportOption,
                      exportSheet: "",
                    },
                  });
              }}
            />
            <div className="individualCheckBox">
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  <select
                    disabled={!googleSheetExportOption ? true : false}
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                          exportSheet: e.target.value,
                        },
                      });
                    }}
                    value={groupSettings?.exportOption?.exportSheet || ""}
                  >
                    <option value="">Select google sheet to export</option>
                    {sheets &&
                      sheets
                        .filter((sheet) => sheet.type === "export")
                        .map((sheet) => {
                          return (
                            <option key={sheet._id} value={sheet._id}>
                              {sheet.spreadsheetTitle}
                            </option>
                          );
                        })}
                  </select>
                </div>
              </span>
            </div>
          </div>
        </div>
        <div className="flex">
          <CheckBox
            label="Download as CSV"
            checked={groupSettings?.exportOption?.csvDownload}
            onChange={(e) => {
              setGroupSettings({
                operationProcedure: {
                  ...groupSettings.operationProcedure,
                },
                exportOption: {
                  ...groupSettings.exportOption,
                  csvDownload: !groupSettings["exportOption"]["csvDownload"],
                },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AutoApproveForm;
